import { render, staticRenderFns } from "./AlarmListComponent.vue?vue&type=template&id=935d54a8&scoped=true"
import script from "./AlarmListComponent.vue?vue&type=script&lang=js"
export * from "./AlarmListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d54a8",
  null
  
)

export default component.exports